import {Trans} from '@lingui/macro';
import React, {FC, ReactNode, useState} from 'react';
import styled from 'styled-components';

import {useInitialEffect} from '../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {
  currentDownloadLocation,
  updateDownloadLocation,
} from '../../../../services/electron/electronBridgeOutbound';
import {SettingsFieldLine} from '../../../common/settingsFieldLine';

/*
 * Props.
 */

interface DownloadLocationPreferenceControlProps {
  title: ReactNode;
  description: ReactNode;
}

/*
 * Style.
 */

const StyledSettingsFieldLine = styled(SettingsFieldLine)`
  div:first-child > & {
    border-top: 0 none;
  }
`;

/*
 * Component.
 */

export const DownloadLocationPreferenceControl: FC<DownloadLocationPreferenceControlProps> = (props) => {
  const [currentLocation, setCurrentLocation] = useState('');

  useInitialEffect(() => {
    currentDownloadLocation().then(setCurrentLocation);
  });

  return (
    <StyledSettingsFieldLine
      title={props.title}
      subtitle={
        <>
          {props.description} {currentLocation}
        </>
      }
      content={
        <Button
          variant={ButtonVariantsEnum.SECONDARY}
          size={VisualSizesEnum.SMALL}
          onClick={async () => {
            await updateDownloadLocation();
            setCurrentLocation(await currentDownloadLocation());
          }}
        >
          <Trans id="change-download-location">Change</Trans>
        </Button>
      }
    />
  );
};
